<template>
  <div :class="`p_onePass${hide ? ' p_driving_hide' : ''}`">
    <el-form
      v-show="!hide"
      v-loading="loading"
      label-position="top"
      :model="form"
      ref="myForm"
      :rules="rules"
      hide-required-asterisk
    >
      <!-- 駕駛學校的商業登記類型 -->
      <el-form-item :label="$t('school.school_identType')" prop="identType">
        <el-select
          v-model="form.identType"
          value-key="code"
          filterable
          :placeholder="$t('school.school_identType_plc')"
        >
          <el-option
            v-for="item in idType"
            :key="item.code"
            :label="$t(item.label)"
            :value="item.code"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- 駕駛學校的商業登記編號 -->
      <el-form-item :label="$t('school.school_identNo')" prop="identNo">
        <el-input
          v-model="form.identNo"
          :placeholder="$t('school.school_identNo_plh')"
        ></el-input>
      </el-form-item>
      <!-- 澳門流動電話 -->
      <!-- <el-form-item :label="$t('message.Verification.mobile')" prop="mobile">
        <el-input
          v-model="form.mobile"
          :placeholder="$t('message.Verification.mobile_placeholder')"
          maxlength="8"
        ></el-input>
      </el-form-item> -->
      <!-- 請選擇任一身份進行業務辦理 -->
      <el-form-item
        v-if="vssData && vssData.spCode === 'D29'"
        :label="$t('school.school_choose')"
        prop="licenseNo"
      >
        <el-radio-group v-model="form.licenseNo" class="m-school-radio-group">
          <el-radio
            v-for="(item, index) in vssData.schoolLicInfoValues"
            :key="index"
            :label="item.id"
          >
            <span>{{ item[`name${$t("message.lan")}`] }}</span>
            <span class="m-school-radio-right">{{ item.status }}</span>
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <!-- 錯誤信息 -->
      <el-form-item v-if="vssData.spCode && vssData.spCode != '00'" label="">
        <msg-box
          :code="vssData.spCode"
          :normalCode="['00', 'D29']"
          :spResult="vssData[`spResult${$t('message.lans')}`]"
        ></msg-box>
      </el-form-item>
      <el-form-item class="submit_btn">
        <!-- v-if="['00', 'D29'].includes(vssData.spCode)" -->
        <!-- <GradientBtn @click="submit" :loading="loading">{{
          $t("message.account_submit")
        }}</GradientBtn> -->
        <!-- v-else-if="!$store.state.isApp" -->
        <GradientBtn
          v-if="vssData.spCode && !['00', 'D29'].includes(vssData.spCode)"
          @click="logout"
          style="margin: 20px 0px"
          >{{ $t("message.logout_account") }}</GradientBtn
        >
        <GradientBtn v-else @click="submit" :loading="loading">{{
          $t("message.account_submit")
        }}</GradientBtn>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import i18n from "../../../../public/lang/index";
import GradientBtn from "../../../components/GradientBtn";
import LoginAPI from "../../../api/LoginAPI";
import safpBridgeObj from "../../../plugins/govmo-js-sdk";
import SchoolRenewApplicationAPI from "../../../api/SchoolRenewApplicationAPI";
import MsgBox from "@/components/MsgBox.vue";
export default {
  components: { GradientBtn, MsgBox },
  data() {
    return {
      loading: false,
      hide: true,
      vssData: {},
      rules: {
        identType: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
          },
        ],
        identNo: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
          },
        ],
        mobile: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
          },
          {
            pattern: /[6]{1}[0-9]{7}/,
            message: i18n.t("message.formRuleMessage.macauMobile"),
            trigger: "blur",
          },
        ],
        licenseNo: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
          },
        ],
      },
      idType: [
        { code: "CO", label: "school.CO" },
        { code: "SO", label: "school.SO" },
      ],
    };
  },
  computed: {
    form: {
      get() {
        return this.$store.state.verifyForm;
      },
      set(value) {
        this.$store.commit("changeVerifyForm", value);
      },
    },
    serviceType() {
      return this.$route.meta.serviceType;
    },
  },
  methods: {
    submit() {
      this.hide = false;
      this.$refs.myForm.validate((valid) => {
        if (valid) {
          localStorage.setItem("verifyForm", JSON.stringify(this.form));
          this.check();
        } else {
          this.hide = false;
        }
      });
    },
    check() {
      const serviceType = this.serviceType;
      const { identType, identNo, licenseNo } = this.form;
      this.loading = true;
      SchoolRenewApplicationAPI.check(
        serviceType,
        identType,
        identNo,
        licenseNo
      )
        .then((res) => {
          this.loading = false;
          this.hide = false;

          this.vssData = res;
          if (res.spCode === "D29") {
            return false;
          }
          const errSpCode = ["00", "D27", "D31"];
          if (res && res.application && !errSpCode.includes(res.spCode)) {
            this.$message({
              type: "error",
              message: res[`spResult${this.$t("message.lans")}`],
            });
          } else {
            localStorage.setItem("form", "");
            this.$store.commit("changeDocumentType", []);
            this.$router.replace("/school-renew");
          }
        })
        .catch((err) => {
          this.loading = false;
          this.hide = false;
          this.$error(err);
        });
    },
    // 一戶通登入
    accountLogin(code, token) {
      const serviceType = this.serviceType;
      this.loading = true;
      LoginAPI.entityAccount(code, token, serviceType)
        .then((res) => {
          this.loading = false;
          localStorage.setItem("accountData", JSON.stringify(res.data));
          localStorage.setItem("accountCode", code);
          localStorage.setItem("authentication", res.headers.authentication);
          // 獲取實體賬戶的商業登記編號
          let identNo = null;
          if (res.data && res.data.profile && res.data.profile.entities) {
            let entities = res.data.profile.entities;
            if (entities.constructor === Array && entities.length > 0) {
              identNo = entities[0].commercialCode;
            }
          }
          if (identNo) this.$set(this.form, "identNo", identNo);
          this.$set(this.form, "mobile", res.data.mobile);
          // this.submit();
          this.hide = false;
        })
        .catch((err) => {
          this.loading = false;
          if (err.message.indexOf("401") != -1) {
            if (this.$store.state.isApp) {
              safpBridgeObj.getToken({
                success(res) {
                  console.log(res);
                  if (res && res.authToken) {
                    this.accountLogin(null, res.authToken, serviceType);
                  }
                },
                fail(res) {
                  console.log(res);
                  this.$message({
                    type: "error",
                    message: this.$t("message.accountLoginFailed"),
                  });
                },
              });
            } else {
              this.$router.replace("/personal-type/SCHOOL/SCHOOL_RENEW");
            }
          } else {
            this.$error(err);
            this.$router.replace("/personal-type/SCHOOL/SCHOOL_RENEW");
          }
        });
    },
    // 登出
    logout() {
      const lang = this.$t("message.lang_account");
      window.location.replace(
        `${process.env.VUE_APP_ACCOUNT_PATH}/${lang}/logout/`
      );
    },
  },
  created() {
    const code = this.$route.query.code || null;
    const token =
      sessionStorage.getItem("accountToken") || this.$route.query.token || null;
    const serviceType = this.serviceType;
    const accountCode = localStorage.getItem("accountCode") || null;
    const accountData = JSON.parse(localStorage.getItem("accountData")) || null;
    if ((token || (code && accountCode != code)) && serviceType) {
      this.accountLogin(code, token);
    } else {
      if (!accountData) {
        this.$message({
          type: "error",
          message: this.$t("message.accountLoginFailed"),
        });
      }
      this.$router.replace("/personal-type/SCHOOL/SCHOOL_RENEW");
    }

    this.$store.state.verifyForm.identType = null;
  },
};
</script>

<style lang="scss" scoped>
.p_driving_hide {
  position: fixed;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  background: #fff;
}
.captcha_row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.getVerify_btn {
  margin-left: 16px;
  min-width: 150px;
}
/deep/.el-radio-group.m-school-radio-group {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  .el-radio__label {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    flex: 1;
  }
  .m-school-radio-right {
    display: inline-block;
    background: #5ba7ad;
    color: #fff;
    padding: 8px 12px;
    border-radius: 4px;
  }
  label.el-radio {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 12px;
    padding: 24px 12px;
    width: 100%;
    border-radius: 4px;
    border: 1px solid #e4e7ed;
  }
}
</style>